// Mirrors the server's `extensions.reason` on a rejected credential or a withheld report card.
// See "Rejected credentials — sign-in vs. link" in CLAUDE.md.
export enum AuthFailureReason {
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SESSION_INVALID = 'SESSION_INVALID',
  ACCESS_LINK_EXPIRED = 'ACCESS_LINK_EXPIRED',
  ACCESS_LINK_INVALID = 'ACCESS_LINK_INVALID',
  REPORT_CARD_UNAVAILABLE = 'REPORT_CARD_UNAVAILABLE',
}

export const SESSION_FAILURE_REASONS = [AuthFailureReason.SESSION_EXPIRED, AuthFailureReason.SESSION_INVALID];
export const ACCESS_LINK_FAILURE_REASONS = [AuthFailureReason.ACCESS_LINK_EXPIRED, AuthFailureReason.ACCESS_LINK_INVALID];
